import { render, staticRenderFns } from "./UserInfo.vue?vue&type=template&id=e65b8cee&scoped=true&"
import script from "./UserInfo.vue?vue&type=script&lang=ts&"
export * from "./UserInfo.vue?vue&type=script&lang=ts&"
import style0 from "./UserInfo.vue?vue&type=style&index=0&id=e65b8cee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e65b8cee",
  null
  
)

export default component.exports